export const contactsData = {
  email: "annamalaipalani11@gmail.com",
  phone: "+917305760719",
  address: "chennai, india",

  sheetAPI: "https://sheetdb.io/api/v1/4c22y87ijlqb2",
};
